var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[(_vm.sentRequest)?_c('div',{staticClass:"text-center py-3"},[_c('creator-request-sent')],1):(!_vm.onboardingUser.guideHowRequestWorksCompleted)?_c('div',[_c('creator-request-explainer')],1):_c('div',[_c('creator-request-create')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }